module.exports = __webpack_public_path__ + "img/img_phone_device.0fbe6b07.png";